var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionsMenu',[_c('delete-post',{attrs:{"post":_vm.post}}),_c('unreport-post',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }